// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store/store.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import requests from '@/util/mapi.js'
import mpublic from '@/util/mpublic.js'
import mhead from './components/mheader.vue'; //顶部
import mfooter from './components/mfooter.vue' //底部
import topBaner from './components/topBaner.vue' //顶部首图
import noData from '@/components/noData' //暂无数据
import BaiduMap from 'vue-baidu-map'

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$Api = requests
Vue.prototype.mpublic = mpublic
Vue.use(ElementUI)
Vue.component('mHeader',mhead)
Vue.component('mFooter',mfooter)
Vue.component('topBaner',topBaner)
Vue.component('noData',noData)
Vue.use(BaiduMap, {
  ak: 'Mx5B7VU9V4CBfcva8SNkKnUj6vM9Rm8A'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  data() {
    return {
      pubPostUrl: localStorage.getItem("pubPostUrl"), //接口前缀
      webList: "", //网站配置
    }
  },
  created() {
    let that = this;
    that.getWebList();
  },
  methods: {
    //网站配置
    getWebList() {
      let that = this;
      that.axios({
        method: 'get',
        url: that.pubPostUrl + 'get_website_conf',
        data: "",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res) => {
        // console.log(res);
        let mres = res.data.data;
        document.title = mres.webname || "重庆兄弟装饰高端定制";
        document.querySelector('meta[name="keywords"]').setAttribute("content", mres.keywords);
        document.querySelector('meta[name="description"]').setAttribute("content", mres.description);
      }).catch((err) => {
        console.log(err);
      });
    },
  }
})



// WEBPACK FOOTER //
// ./src/main.js